/**
 * The one definition of the order the help-center sidebar lists articles in. Used by the
 * sidebar itself and by the previous / next buttons so they can never disagree.
 */

const pinSort = (a, b) => (b.pinToTop ? 1 : 0) - (a.pinToTop ? 1 : 0);
const titleSort = (a, b) => pinSort(a, b) || (a.title || '').localeCompare(b.title || '');

/**
 * @param {object} opts
 * @param {Array} opts.articles      already filtered list (search / tag filter applied)
 * @param {Array} opts.headerTags    customer header tags, in display order
 * @param {boolean} opts.showGrouped true when the sidebar shows tag sections
 * @param {Function} opts.getTags    article → array of tag names (shadow + ai tags included)
 * @returns {Array} new array, never the input
 */
export function orderHelpArticles({
    articles = [], headerTags = [], showGrouped = false, getTags = () => [],
}) {
    if (!showGrouped) {
        return [...articles].sort(titleSort);
    }
    const seen = new Set();
    const ordered = [];
    headerTags.forEach(tag => {
        [...articles]
            .filter(a => getTags(a).includes(tag))
            .sort(titleSort)
            .forEach(a => {
                if (!seen.has(a.id)) {
                    seen.add(a.id);
                    ordered.push(a);
                }
            });
    });
    [...articles]
        .filter(a => !seen.has(a.id))
        .sort(titleSort)
        .forEach(a => ordered.push(a));
    return ordered;
}

export { pinSort, titleSort };
